import Spinner from "react-bootstrap/Spinner";

const LoadingSpinner = () => {
  return <Spinner animation="border" />;
};

export default LoadingSpinner;
